import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'reserva',
    loadChildren: () => import('./reserva/reserva.module').then( m => m.ReservaPageModule)
  },
  {
    path: 'servicios',
    loadChildren: () => import('./servicios/servicios.module').then( m => m.ServiciosPageModule)
  },
  {
    path: 'ingreso',
    loadChildren: () => import('./ingreso/ingreso.module').then( m => m.IngresoPageModule)
  },
  {
    path: 'turno',
    loadChildren: () => import('./turno/turno.module').then( m => m.TurnoPageModule)
  },
  {
    path: 'fuera-horario',
    loadChildren: () => import('./fuera-horario/fuera-horario.module').then( m => m.FueraHorarioPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'flujo-transito-nivel1',
    loadChildren: () => import('./flujo-transito/nivel1/nivel1.module').then( m => m.Nivel1PageModule)
  },
  {
    path: 'flujo-transito-nivel2',
    loadChildren: () => import('./flujo-transito/nivel2/nivel2.module').then( m => m.Nivel2PageModule)
  },
  {
    path: 'flujo-transito-reserva',
    loadChildren: () => import('./flujo-transito/reserva-transito/reserva-transito.module').then( m => m.ReservaTransitoPageModule)
  },
  {
    path: 'flujo-dideco-reserva',
    loadChildren: () => import('./flujo-dideco/reserva-dideco/reserva-dideco.module').then( m=> m.ReservaDidecoPageModule)
  },
  {
    path: 'reserva-transito',
    loadChildren: () => import('./flujo-transito/reserva-transito/reserva-transito.module').then( m => m.ReservaTransitoPageModule)
  },
  {
    path: 'flujo-dideco-nivel1',
    loadChildren: () => import('./flujo-dideco/nivel1/nivel1.module').then( m => m.Nivel1PageModule)
  },
  {
    path: 'flujo-finanzas',
    loadChildren: () => import('./flujo-finanzas/flujo-finanzas.module').then( m => m.FlujoFinanzasPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
